import { combineReducers } from "redux";
import authReducer from './authReducer';
import landingDataReducer from "./landingDataReducer";

const rootReducer = combineReducers({
    authReducer,
    landingDataReducer,
})

export default rootReducer;